import React, { useEffect, useState } from 'react';
import {
  Avatar,
  Box,
  Button,
  FormControl,
  InputAdornment,
  MenuItem,
  Select,
  Stack,
  TextField,
  Typography,
  Chip,
  CircularProgress,
  useTheme,
  useMediaQuery,
} from '@mui/material';
import { organizationAPI } from '../../api/requests/organization/organizationAPI';
import { useNavigate } from 'react-router-dom';
import dashboardHalfImage from '../../assets/LandingPage/Hero/dashboard-half-image.png';
import no_data_img from '../../assets/no_data_img.svg';
import Navbar from '../../components/Header/Navbar';
import { RoundedButton, RoundedSelect } from '../../components/Form';
import SearchInputField from '../../components/SearchBar/SearchInputField';

export default function Dashboard({
  scrollToSection,
  featuresRef,
  whyChooseUsRef,
  pricingRef,
  homeRef,
  setSelectedOrgName,
}) {
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('md'));

  const orgOption = [
    {
      id: 1,
      value: 'Owned',
      label: 'Owned'
    },
    {
      id: 2,
      value: 'Joined',
      label: 'Joined'
    },
  ];
  const url = window.location.href.split('?')[1]?.split('=')[1];
  const [orgData, setOrgData] = useState(null);
  const [joined, setJoined] = useState(0);
  const [owned, setOwned] = useState(0);
  const [org, setOrg] = useState(
    url ? url.charAt(0).toUpperCase() + url.slice(1) : orgOption[0].value
  );
  const [orgError, setOrgError] = useState(null);
  const [loader, setLoader] = useState(false);
  const [isSearchActive, setIsSearchActive] = useState(false);

  const navigate = useNavigate();


  const handleOrgPresentOrNot = (res) => {
    if (res.length === 0) {
      setOrgError('No organizations to show here');
    }
  };

  async function getOrgData() {
    setOrgError('');
    try {
      setLoader(true);
      await organizationAPI.getOrganizations().then((res) => {
        setOrgData(res);
        setOwned(res.filter((x) => x.isCreator));
        setJoined(res.filter((x) => !x.isCreator));
        handleOrgPresentOrNot(res);
      });
      setLoader(false);
    } catch (err) {
      setOrgError(err.message);
      setLoader(false);
    }
  }

  async function getOrgSearch(name) {
    setOrgError('');
    try {
      setLoader(true);
      const res = await organizationAPI.getOrganizations();
      const data = res.filter((x) => x.name.toLowerCase().includes(name.toLowerCase()));
      setOrgData(data);
      handleOrgPresentOrNot(data);
      setLoader(false);
    } catch (err) {
      setOrgError(err.message);
      setLoader(false);
    }
  }

  useEffect(() => {
    getOrgData();
  }, []);

  const handleCreateOrganization = () => {
    navigate('/onboarding?create=true');
    localStorage.setItem('onboardingStep', '1');
  };

  const handleJoinOrganization = () => {
    navigate('/onboarding?join=true');
    localStorage.setItem('onboardingStep', '-1');
  };

  return (
    <div className="main-wraper">
      <Navbar />
      <Box
        sx={{
          display: 'flex',
          flexDirection: { xs: 'column-reverse', md: 'row' },
          width: '100%',
          minHeight: '100vh',
        }}
      >
        <style>
          {`
          .custom-scrollbar {
            max-height: 230px;
            overflow-y: auto;
            scrollbar-width: thin;
            scrollbar-color: rgba(139, 164, 255, 1) rgba(241, 241, 241, 1);
          }

          .custom-scrollbar::-webkit-scrollbar {
            width: 5px;
          }

          .custom-scrollbar::-webkit-scrollbar-track {
            background: #e4efef;
          }

          .custom-scrollbar::-webkit-scrollbar-thumb {
            background-color: #354150;
            border-radius: 2px;
          }
        `}
        </style>
        <Box
          sx={{
            width: { xs: '100%', md: '50%' },
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            flexDirection: 'column',
            textAlign: 'left',
            padding: { xs: '0', md: '0' },
            backgroundColor: 'var(--color-bg-secondary)',
          }}
        >
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'flex-start',
              m: 1,
              width: { md: '90%', lg: '65%', xs: '90%' },
            }}
          >
            <Typography
              sx={{
                fontFamily: 'Poppins',
                fontSize: '32px',
                fontWeight: 600,
                color: 'var(--color-primary)',
              }}
            >
              Welcome to Optigrit!
            </Typography>
            <Typography
              sx={{
                fontFamily: 'Poppins',
                fontSize: '16px',
                fontWeight: 400,
                color: 'var(--color-text-secondary)',
                mt: '12px',
                mb: '20px',
              }}
            >
              Start by creating or joining an organization to begin managing your team and projects.
            </Typography>
          </Box>
          <Box
            sx={{
              width: { md: '90%', lg: '65%', xs: '90%' },
              mb: 4,
            }}
          >
            <Stack
              sx={{
                flexDirection: 'row',
                justifyContent: 'space-between', 
                flexWrap: 'wrap',
                gap: '12px',
                width: '100%',
              }}
            >
              <Stack sx={{flex: 1, flexBasis: '220px'}} >
                <SearchInputField
                  onChange={(val) => getOrgSearch(val)}
                  placeholder="Search organizations..."
                />
              </Stack>
              <Stack sx={{flex: 1}} >
                <RoundedSelect
                  value={org}
                  onChange={(e) => setOrg(e.target.value)}
                  options={orgOption}
                  placeholder="Organization Type"
                />
                </Stack>
            </Stack>
          </Box>
          {loader ? (
            <Box
              sx={{
                overflowY: 'scroll',
                height: '230px',
                width: { md: '90%', lg: '65%', xs: '90%' },
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              <CircularProgress />
            </Box>
          ) : (
            <Stack
              gap={'12px'}
              className="custom-scrollbar"
              sx={{
                overflowY: 'scroll',
                height: '230px',
                alignItems: 'flex-start',
                width: { md: '90%', lg: '65%', xs: '90%' },
              }}
            >
              {orgData && orgData.length > 0 ? (
                <>
                  {orgData &&
                    orgData.map((x) => {
                      if (org === 'Owned' && x.isCreator) {
                        return (
                          <Stack
                            sx={{
                              flexDirection: 'row',
                              borderRadius: '12px',
                              width: '-webkit-fill-available',
                              cursor: 'pointer',
                              border: '1px solid var(--color-border)',
                              p: '12px',
                              transition: 'all 0.2s ease',
                              '&:hover': {
                                borderColor: 'var(--color-primary)',
                                boxShadow: '0 2px 8px rgba(59, 130, 246, 0.1)',
                                '& .org-avatar': {
                                  transform: 'scale(1.05)',
                                },
                              },
                            }}
                            key={x.id}
                            onClick={() => {
                              localStorage.setItem('orgName', x.name);
                              navigate(`/org/${x.name}/dashboard`);
                            }}
                          >
                            <Stack sx={{ justifyContent: 'center' }}>
                              {x.logoLink ? (
                                <Avatar
                                  src={x.logoLink}
                                  className="org-avatar"
                                  sx={{
                                    width: '60px',
                                    height: '60px',
                                    borderRadius: '12px',
                                    transition: 'transform 0.2s ease',
                                    border: '2px solid var(--color-border)',
                                  }}
                                />
                              ) : (
                                <Avatar
                                  className="org-avatar"
                                  sx={{
                                    width: '60px',
                                    height: '60px',
                                    borderRadius: '12px',
                                    fontSize: '24px',
                                    bgcolor: 'var(--color-primary)',
                                    color: '#fff',
                                    transition: 'transform 0.2s ease',
                                    border: '2px solid var(--color-border)',
                                  }}
                                >
                                  {x.name.charAt(0)}
                                </Avatar>
                              )}
                            </Stack>
                            <Stack sx={{ width: '100%', overflow: 'hidden' }}>
                              <Box sx={{ pl: '8px' }}>
                                <Typography
                                  sx={{
                                    fontFamily: 'Poppins',
                                    fontSize: '18px',
                                    fontWeight: '500',
                                    marginRight: '8px',
                                    color: 'var(--color-text)',
                                    overflow: 'hidden',
                                    textOverflow: 'ellipsis',
                                    whiteSpace: 'nowrap',
                                  }}
                                >
                                  {x.name}
                                </Typography>

                                <Typography
                                  sx={{
                                    fontFamily: 'Poppins',
                                    fontSize: '14px',
                                    fontWeight: '400',
                                    marginRight: '8px',
                                    color: 'var(--color-text-secondary)',
                                    overflow: 'hidden',
                                    textOverflow: 'ellipsis',
                                    whiteSpace: 'nowrap',
                                  }}
                                >
                                  {x.description}
                                </Typography>
                              </Box>
                              <Box
                                sx={{
                                  display: 'flex',
                                  justifyContent: 'space-between',
                                  mt: 0.5,
                                  flexDirection: { xs: 'column', md: 'row' },
                                  alignItems: { xs: 'flex-start', md: 'center' },
                                  gap: 1,
                                }}
                              >
                                <Stack
                                  sx={{
                                    pl: '8px',
                                    pt: '8px',
                                    gap: '8px',
                                    overflow: 'hidden',
                                    alignItems: 'center',
                                  }}
                                >
                                  <Stack direction={'row'} gap={'4px'}>
                                    {x.usersData?.slice(0, 3).map((user, index) =>
                                      user.profilePhotoLink ? (
                                        <Avatar
                                          src={user.profilePhotoLink}
                                          sx={{ 
                                            width: '20px', 
                                            height: '20px',
                                            border: '2px solid var(--color-border)',
                                            ml: index > 0 ? '-8px' : '0px',
                                            zIndex: 3 - index,
                                            transition: 'transform 0.2s ease',
                                            '&:hover': {
                                              transform: 'scale(1.2)',
                                              zIndex: 10,
                                            },
                                          }}
                                          key={index}
                                        />
                                      ) : (
                                        <Avatar
                                          sx={{
                                            width: '20px',
                                            height: '20px',
                                            textTransform: 'capitalize',
                                            fontSize: '10px',
                                            pt: '1px',
                                            border: '2px solid var(--color-border)',
                                            ml: index > 0 ? '-8px' : '0px',
                                            zIndex: 3 - index,
                                            bgcolor: index === 0 ? '#ef4444' : index === 1 ? '#10b981' : '#f59e0b',
                                            color: '#fff',
                                            transition: 'transform 0.2s ease',
                                            '&:hover': {
                                              transform: 'scale(1.2)',
                                              zIndex: 10,
                                            },
                                          }}
                                          key={index}
                                        >
                                          {user.firstName.charAt(0)}
                                        </Avatar>
                                      )
                                    )}
                                    <Typography
                                      sx={{
                                        fontFamily: 'Poppins',
                                        fontSize: '12px',
                                        fontWeight: 400,
                                        color: 'var(--color-text-secondary)',
                                        ml: 0.5,
                                      }}
                                    >
                                      {`${x.totalUsers} members`}
                                    </Typography>
                                  </Stack>
                                </Stack>
                                <Chip
                                  label={x.planName}
                                  variant="outlined"
                                  color="primary"
                                  sx={{
                                    flexShrink: 0,
                                    color: 'var(--color-primary)',
                                    border: '1px solid var(--color-primary)',
                                    background: 'var(--color-bg-secondary)',
                                    borderRadius: '12px',
                                    fontFamily: 'Poppins',
                                    fontSize: '12px',
                                    fontWeight: 500,
                                    padding: '0px 12px',
                                    height: '28px',
                                    ml: '8px',
                                    transition: 'all 0.2s ease',
                                  }}
                                />
                              </Box>
                            </Stack>
                          </Stack>
                        );
                      }
                      if (org === 'Joined' && !x.isCreator) {
                        return (
                          <Stack
                            sx={{
                              flexDirection: 'row',
                              borderRadius: '12px',
                              width: { xs: '90%', md: '93%' },
                              cursor: 'pointer',
                              border: '1px solid var(--color-border)',
                              p: '12px',
                              transition: 'all 0.2s ease',
                              '&:hover': {
                                borderColor: 'var(--color-primary)',
                                boxShadow: '0 2px 8px rgba(59, 130, 246, 0.1)',
                                '& .org-avatar': {
                                  transform: 'scale(1.05)',
                                },
                              },
                            }}
                            key={x.id}
                            onClick={() => {
                              localStorage.setItem('orgName', x.name);
                              navigate(`/org/${x.name}/dashboard`);
                            }}
                          >
                            <Stack sx={{ justifyContent: 'center' }}>
                              {x.logoLink ? (
                                <Avatar
                                  src={x.logoLink}
                                  className="org-avatar"
                                  sx={{
                                    width: '60px',
                                    height: '60px',
                                    borderRadius: '12px',
                                    transition: 'transform 0.2s ease',
                                    border: '2px solid var(--color-border)',
                                  }}
                                />
                              ) : (
                                <Avatar
                                  className="org-avatar"
                                  sx={{
                                    width: '60px',
                                    height: '60px',
                                    borderRadius: '12px',
                                    fontSize: '24px',
                                    bgcolor: 'var(--color-primary)',
                                    color: '#fff',
                                    transition: 'transform 0.2s ease',
                                    border: '2px solid var(--color-border)',
                                  }}
                                >
                                  {x.name.charAt(0)}
                                </Avatar>
                              )}
                            </Stack>
                            <Stack sx={{ width: '100%', overflow: 'hidden' }}>
                              <Box sx={{ pl: '8px' }}>
                                <Typography
                                  sx={{
                                    fontFamily: 'Poppins',
                                    fontSize: '18px',
                                    fontWeight: '500',
                                    marginRight: '8px',
                                    color: 'var(--color-text-primary)',
                                    overflow: 'hidden',
                                    textOverflow: 'ellipsis',
                                    whiteSpace: 'nowrap',
                                  }}
                                >
                                  {x.name}
                                </Typography>

                                <Typography
                                  sx={{
                                    fontFamily: 'Poppins',
                                    fontSize: '14px',
                                    fontWeight: '400',
                                    marginRight: '8px',
                                    color: 'var(--color-text-secondary)',
                                    overflow: 'hidden',
                                    textOverflow: 'ellipsis',
                                    whiteSpace: 'nowrap',
                                  }}
                                >
                                  {x.description}
                                </Typography>
                              </Box>
                              <Box
                                sx={{
                                  display: 'flex',
                                  justifyContent: 'space-between',
                                  mt: 0.5,
                                  flexDirection: { xs: 'column', md: 'row' },
                                  alignItems: { xs: 'flex-start', md: 'center' },
                                  gap: 1,
                                }}
                              >
                                <Stack
                                  sx={{
                                    pl: '8px',
                                    pt: '8px',
                                    gap: '8px',
                                    overflow: 'hidden',
                                    alignItems: 'center',
                                  }}
                                >
                                  <Stack
                                    sx={{ flexDirection: 'row', gap: '8px', alignItems: 'center' }}
                                  >
                                    <Stack direction={'row'} gap={'4px'}>
                                      {x.usersData?.slice(0, 3).map((user, index) =>
                                        user.profilePhotoLink ? (
                                          <Avatar
                                            src={user.profilePhotoLink}
                                            sx={{ 
                                              width: '20px', 
                                              height: '20px',
                                              border: '2px solid var(--color-border)',
                                              ml: index > 0 ? '-8px' : '0px',
                                              zIndex: 3 - index,
                                              transition: 'transform 0.2s ease',
                                              '&:hover': {
                                                transform: 'scale(1.2)',
                                                zIndex: 10,
                                              },
                                            }}
                                            key={index}
                                          />
                                        ) : (
                                          <Avatar
                                            sx={{
                                              width: '20px',
                                              height: '20px',
                                              textTransform: 'capitalize',
                                              fontSize: '10px',
                                              pt: '1px',
                                              border: '2px solid var(--color-border)',
                                              ml: index > 0 ? '-8px' : '0px',
                                              zIndex: 3 - index,
                                              bgcolor: index === 0 ? '#8b5cf6' : index === 1 ? '#f97316' : '#06b6d4',
                                              color: '#fff',
                                              transition: 'transform 0.2s ease',
                                              '&:hover': {
                                                transform: 'scale(1.2)',
                                                zIndex: 10,
                                              },
                                            }}
                                            key={index}
                                          >
                                            {user.firstName.charAt(0)}
                                          </Avatar>
                                        )
                                      )}
                                      <Typography
                                        sx={{
                                          fontFamily: 'Poppins',
                                          fontSize: '12px',
                                          fontWeight: 400,
                                          color: 'var(--color-text-secondary)',
                                          ml: 0.5,
                                        }}
                                      >
                                        {x.usersData.length > 0 && `${x.totalUsers} members`}
                                      </Typography>
                                    </Stack>
                                  </Stack>
                                </Stack>
                                <Chip
                                  label={x.planName}
                                  variant="outlined"
                                  color="primary"
                                  sx={{
                                    flexShrink: 0,
                                    color: 'var(--color-primary)',
                                    border: '1px solid var(--color-primary)',
                                    background: 'var(--color-bg-secondary)',
                                    borderRadius: '12px',
                                    fontFamily: 'Poppins',
                                    fontSize: '12px',
                                    fontWeight: 500,
                                    padding: '0px 12px',
                                    height: '28px',
                                    ml: '8px',
                                    transition: 'all 0.2s ease',
                                  }}
                                />
                              </Box>
                            </Stack>
                          </Stack>
                        );
                      }
                    })}
                  {org === 'Owned' && !orgError && owned?.length === 0 && (
                    <Typography sx={{ 
                      fontSize: '16px', 
                      fontWeight: 500, 
                      color: 'var(--color-text-secondary)',
                      textAlign: 'center',
                      py: 4,
                    }}>
                      No organizations to show here
                    </Typography>
                  )}
                  {org === 'Joined' && !orgError && joined?.length === 0 && (
                    <Typography sx={{ 
                      fontSize: '16px', 
                      fontWeight: 500, 
                      color: 'var(--color-text-secondary)',
                      textAlign: 'center',
                      py: 4,
                    }}>
                      No organizations to show here
                    </Typography>
                  )}
                  {orgError && (
                    <Typography sx={{ 
                      fontSize: '16px', 
                      fontWeight: 500, 
                      color: 'var(--color-error)',
                      textAlign: 'center',
                      py: 4,
                    }}>
                      {orgError}
                    </Typography>
                  )}
                </>
              ) : (
                <Box
                  sx={{
                    backgroundColor: 'var(--color-bg-secondary)',
                    display: 'flex',
                    flexDirection: { xs: 'column', md: 'row' },
                    alignItems: 'center',
                    gap: 2,
                    p: 4,
                    borderRadius: '16px',
                    border: '1px solid var(--color-border)',
                  }}
                >
                  <Box
                    sx={{
                      display: 'flex',
                      flexDirection: 'column',
                      alignItems: 'center',
                    }}
                  >
                    <Typography
                      sx={{
                        fontFamily: 'Montserrat',
                        fontSize: '16px',
                        fontWeight: '500',
                        color: 'var(--color-text-primary)',
                        mb: 1,
                      }}
                    >
                      It looks like you haven’t joined or created any organizations yet.
                    </Typography>{' '}
                    <Typography
                      sx={{
                        fontFamily: 'Montserrat',
                        fontSize: '16px',
                        fontWeight: '400',
                        color: 'var(--color-text-secondary)',
                      }}
                    >
                      Get started by creating a new organization or joining one with an invite
                      code.
                    </Typography>
                  </Box>

                  <img src={no_data_img} alt="" />
                </Box>
              )}
            </Stack>
          )}

          <Box
            sx={{
              width: { md: '90%', lg: '65%', xs: '90%' },
              mt: 3,
              mb: 2,
              display: 'flex',
              flexDirection: 'column',
              gap: 2,
            }}
          >
            <RoundedButton
              variant="contained"
              fullWidth
              onClick={handleCreateOrganization}
            >
              Create a New Organization
            </RoundedButton>
            <RoundedButton
              variant="outlined"
              fullWidth
              onClick={handleJoinOrganization}
              >
              Join with an Invite Code
              </RoundedButton>
          </Box>
        </Box>
        <Box
          sx={{
            width: { xs: '100%', md: '50%' },
            backgroundColor: 'var(--color-bg)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'right',
            padding: { xs: '30px 0', md: '0' },
          }}
        >
          <img
            alt=""
            src={dashboardHalfImage}
            style={{
              maxWidth: '90%',
              height: 'auto',
              maxHeight: isSmallScreen ? '50%' : '80%',
            }}
          />
        </Box>
      </Box>
    </div>
  );
}
